import React from "react";

export const purewebContext = React.createContext({});
